import messages from './gallery-list-translations';
import * as $ from 'jquery';
import Paginate from 'vuejs-paginate';
import { GalleryService } from '../../services/galleryService';
import { ApplicationConfig } from '../../../shared/applicationConfig';
import { SharedService } from '../../../shared/services/sharedService';
import thumbnailmapList from '../../../shared/components/thumbnailmap-list/thumbnailmap-list.vue';
import { AuthService } from '../../../login/services/authService';

export default {
    name: 'instamapsGalleryList',
    i18n: {
        messages,
    },
    data: () => {
        return {
            isLoading: false,
            minCharsToFilterText: ApplicationConfig.minCharsToFilterText,
            results: [],
            newestElement: undefined,
            searchInput: '',
            selectedPage: 1,
            selectedSortConcept: GalleryService.defaultGallerySortConcept,
            paginating: false,
            sorting: false,
            availableMaps: 0,
            pageElements: {
                numPages: 1,
                currentPage: 1,
                elements: [],
                currentSortConcept: GalleryService.defaultGallerySortConcept,
                currentOrder: ApplicationConfig.defaultSortOrder,
            },
        };
    },
    components: {
        paginate: Paginate,
        thumbnailmapList,
    },
    props: {
        selectedLang: { type: String },
    },
    filters: {
        dateFormat: (value) => SharedService.dateFormat(value),
        dateDay: (value) => SharedService.dateDay(value),
        dateMonth: (value, lang) => SharedService.dateMonth(value, lang),
        dateYear: (value) => SharedService.dateYear(value),
        truncate: (value, length) => SharedService.truncateText(value, length),
    },
    computed: {
        galleryItems: function () {
            this.pageElements = GalleryService.getElements(this.results, this.selectedPage, this.searchInput, this.pageElements.currentSortConcept, this.pageElements.currentOrder, this.selectedSortConcept, this.paginating, this.sorting, this.availableMaps);
            this.paginating = false;
            this.sorting = false;
            return this.pageElements.elements;
        }
    },
    watch: {
        'results': function () {
            this.loaded();
        }    
    },
    methods: {
        scrollToTop() {
            setTimeout(function () {
                $('#scroller').animate({
                    scrollTop: 0,
                }, 1000);
            }, 500);
        },
        clickCallback(pageNum) {
            this.selectedPage = pageNum;
            this.paginating = true;
            this.scrollToTop();
            if(this.results.length < this.availableMaps){
                this.loading();
            }
        },
        sortBy(concept) {
            this.loading();
            this.selectedSortConcept = concept;
            this.sorting = true;
            this.scrollToTop();
            const self = this;
            setTimeout(function () {
                self.loaded();
            }, 500);
        },
        initialize() {
            this.selectedSortConcept = GalleryService.defaultGallerySortConcept;
            this.pageElements.currentSortConcept = GalleryService.defaultGallerySortConcept;
            this.currentOrder = ApplicationConfig.defaultSortOrder;
        },
        loading: function () {
            this.isLoading = true;
            this.$emit('loading');
        },
        loaded: function () {
            this.isLoading = false;
            this.$emit('loaded', { availableMaps: this.availableMaps, lastActivity: (this.newestElement ? this.newestElement.dataPublicacio : '-') });
        },
        loadAllMaps: function(){
            GalleryService.getAllPublicsMaps().then((elements) => {
                this.paginating = true;
                this.results = elements;
                this.newestElement = SharedService.newestElement(this.results);
                this.loaded();
            });
        },
        clonarMapa: function(event){
            this.$emit('clonarMapa', {mapa: event.mapa});
        }
    },
    mounted() {
        $('.search-sort-toggle').on('click', () => {
            ($('.search-sort').css('display') === 'none') ? $('.search-sort').css('display', 'block'): $('.search-sort').css('display', 'none');
        });
        this.loading();
        this.initialize();

        if (this.$route.query.user && !this.$route.query.tipusApp){
            GalleryService.getSearchMaps(this.$route.query.user).then((elements) => {
                this.results = elements;
                this.availableMaps = elements.length;
                this.newestElement = SharedService.newestElement(elements);
                if (this.$route.query.q){
                    this.searchInput = this.$route.query.q;
                }
            });
        }else if(this.$route.query.uid && this.$route.query.token){
            GalleryService.loginUser(this.$route.query.token).then((response) => {
                if (response && response.body) {
                    if (response.body.status === "ERROR") {
                        throw "Error";
                    }
                    else {
                        AuthService.setToken(response.body.token);
                        AuthService.setUid(response.body.uid);
                        AuthService.setTipusEntitat(response.body.tipusEntitat);
                        this.$emit('login');
                    }
                }
			});
		} else if (this.$route.query.user && this.$route.query.tipusApp) {
			
			GalleryService.getMapsTipusApp(this.$route.query.user, this.$route.query.tipusApp).then((elements) => {
                this.results = elements;
                this.availableMaps = elements.length;
                this.newestElement = SharedService.newestElement(elements);
            });

        }else{
            GalleryService.getNumGaleria().then((numMaps) => {
                this.availableMaps = numMaps;
                if (this.$route.query.q){
                    GalleryService.getSearchMaps(this.$route.query.q).then((elements) => {
                        this.results = elements;
                        this.newestElement = SharedService.newestElement(elements);
                        this.searchInput = this.$route.query.q;
                        this.loadAllMaps();
                    });
                }else {
                    GalleryService.getAllElements().then((elements) => {
                        this.results = elements;
                        this.newestElement = SharedService.newestElement(elements);
                        this.loadAllMaps();
                    });
                }
            });
        }
    },
};



// WEBPACK FOOTER //
// ./src/gallery/components/gallery-list/gallery-list.js